"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "casal-cermelli": {
    "7ee56449": [{
      "hkey": "747590c5",
      "slug": "fontanasse",
      "name": "Fontanasse",
      "primary": true,
      "skipSearch": false
    }],
    "fantanasse": [{
      "hkey": "747590c5",
      "slug": "fontanasse",
      "name": "Fontanasse",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "f34e31d8": [{
      "hkey": "89e4108b",
      "slug": "casal-cermelli",
      "name": "Casal Cermelli",
      "primary": true,
      "skipSearch": false
    }],
    "rossina": [{
      "hkey": "89e4108b",
      "slug": "casal-cermelli",
      "name": "Casal Cermelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;